<template>
<div id="secure">

    <NewTopMenu />
    <div class="container">

        <div class="columns">
            <div class="column is-12">
                <div class="card">
                    <div class="card-header">
                        <p class="card-header-title"><nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
                        <ul>
                            <li><a v-on:click="goManageForms()">Created Forms</a></li>
                            <li class="is-active"><a href="#" aria-current="page">{{ formName }} Submissions</a></li>
                        </ul>
                        </nav></p>
                    </div>
                    <loading :active.sync="isLoading" 
                        :can-cancel="false" 
                        :is-full-page="false">
                    </loading>
                    <div class="card-header">
                        <p class="card-header-title">Select Date 
                            <datepicker @closed="getSubmissions(selectedDate,1)"  v-model="selectedDate" wrapper-class="datepicker" placeholder="Select Date" :value="todayDate" :class="$style.datepicker" :calendar-button="true" calendar-button-icon="fa fa-calendar" v-if="period == 1"></datepicker>
                        </p>  
                        <b-select id="duration" name="duration" v-model="duration" class="header-input" @input="getSubmissions()"  v-if="period == 2">
                            <option selected value="1">January</option>
                            <option selected value="2">February</option>
                            <option selected value="3">March</option>
                            <option selected value="4">April</option>
                            <option selected value="5">May</option>
                            <option selected value="6">June</option>
                            <option selected value="7">July</option>
                            <option selected value="8">August</option>
                            <option selected value="9">September</option>
                            <option selected value="10">October</option>
                            <option selected value="11">November</option>
                            <option selected value="12">December</option>
                        </b-select>
                    </div>

                    <div class="card-content" style="min-height: 500px;">
                        <div class="columns">                            
                            <div class="column is-12">
                                <div class="columns bottom-border">
                                    <div class="column">
                                        <b>Received on</b>
                                    </div>
                                    <div class="column" v-for="getDetail in formDetails" :key="getDetail.id">
                                        <b>{{ getDetail.fieldName }}</b>
                                    </div>
                                </div>

                                <div class="columns" v-for="mySubmission in listOfSubmissions" :key="mySubmission.no">
                                    <div class="column">
                                        {{ mySubmission.createdAt }}
                                    </div>                                        
                                    <div class="column" v-show="formDetailsLength > 0">{{ mySubmission.field01 }} </div>                                        
                                    <div class="column" v-show="formDetailsLength > 1">{{ mySubmission.field02 }} </div>                                        
                                    <div class="column" v-show="formDetailsLength > 2">{{ mySubmission.field03 }} </div>                                        
                                    <div class="column" v-show="formDetailsLength > 3">{{ mySubmission.field04 }} </div>                                        
                                    <div class="column" v-show="formDetailsLength > 4">{{ mySubmission.field05 }} </div>                                        
                                    <div class="column" v-show="formDetailsLength > 5">{{ mySubmission.field06 }} </div>                                        
                                    <div class="column" v-show="formDetailsLength > 6">{{ mySubmission.field07 }} </div>
                                    <div class="column" v-show="formDetailsLength > 7">{{ mySubmission.field08 }} </div>
                                    <div class="column" v-show="formDetailsLength > 8">{{ mySubmission.field09 }} </div>
                                    <div class="column" v-show="formDetailsLength > 9">{{ mySubmission.field10 }} </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NewTopMenu from "./../../NewTopMenu";
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Datepicker from 'vuejs-datepicker';

export default {
    name: "ManageFormsEdit",
    components: {
        NewTopMenu,
        Loading,
        Datepicker
    },
    data() {
        return {
            formId: '',
            formName: '',
            formDetails: [],
            formDetailsLength: 0,
            period: 1,
            actionYear: 0,
            actionMonth: 0,
            displayMonth: '',
            actionDate: '',
            listOfSubmissions: [],
            todayDateDisplay: '',
            isLoading: false,
            duration: 0,
            selectedDate: '',
            todayDay : 0,
            todayMonth : 0,
            todayYear : 0,
            todayDate: '',
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    created() {
        var currentDate = new Date();
        var currentDay = currentDate.getDate();
        if (currentDate.getDate() < 10){
            currentDay = "0" + currentDay;
        }
        var currentMonth = currentDate.getMonth() + 1;  //since month starts from 0
        this.duration = currentMonth;
        this.displayMonth = this.displayMonthName(currentMonth)
        if (currentMonth < 10){
            currentMonth = "0" + currentMonth;
        }
        this.actionDate = currentDate.getFullYear() + "" + currentMonth + "" + currentDay;
        this.actionYear = currentDate.getFullYear()

        this.todayDateDisplay = currentDay + "/" + currentMonth + "/" + this.actionYear
        
        this.formId = this.$store.getters.getFormId;
        console.log("151 this.formId: " + this.formId)
        if (this.formId.trim.length < 1){
            this.formId = localStorage.getItem('FORM_ID')
        }

        this.formName = this.$store.getters.getFormName;
        if (this.formName.trim.length < 1){
            this.formName = localStorage.getItem('FORM_NAME')
        }
        
        this.todayDay = currentDate.getDate()
        this.todayMonth = currentDate.getMonth()
        this.todayYear = currentDate.getFullYear()
    },
    mounted(){
        this.getSubmissions(this.actionDate,0)
    },
    methods: {
        
        getSubmissions(getActionDate,caller){
            console.log("Entering getBehaviors with " + getActionDate + ", " + caller)

            if (caller == 1){   //called by datepicker
                var setActionDate = "";
                var setMonth = getActionDate.getMonth() + 1;
                var setDay = getActionDate.getDate();
                if (setMonth < 10){
                    setMonth = "0" + setMonth
                }
                if (setDay < 10){
                    setDay = "0" + setDay
                }
                setActionDate = getActionDate.getFullYear() + setMonth + setDay
                getActionDate = setActionDate
                this.actionDate = setActionDate
            }else{
                //this.selectedDate = this.actionDate
                console.log("year: " + this.todayYear + " day: " + this.todayDay + " mo: " + this.todayMonth)
                this.selectedDate = new Date(this.todayYear, this.todayMonth,this.todayDay )
            }
            
            let self = this;
            self.isLoading = true;

            if (self.period == 1){  //only for today                
                axios.defaults.headers.common['Authorization'] = localStorage.getItem('newToken')
                axios.defaults.responseType = 'json'
                axios.post(process.env.NEW_ENDPOINT + '/form/listSubmissions', {
                        loginEmail: localStorage.getItem('email'),
                        token: localStorage.getItem('newToken'),
                        schoolId: localStorage.getItem('schoolID'),
                        country: localStorage.getItem('country'),
                        formId: self.formId,
                        period: self.period,
                        actionDate: getActionDate,
                        displayFormDetails: true
                    })
                    .then(response => {
                        console.log("191 response.data")
                        console.log(response.data)
                        self.formDetails = response.data.formDetails
                        self.formDetailsLength = self.formDetails.length
                        self.listOfSubmissions = response.data.submissions
                        self.isLoading = false                    
                        console.log("194 this.formDetails: ")
                        console.log(self.formDetails.length)
                        console.log("194 this.listOfSubmissions: ")
                        console.log(self.listOfSubmissions)
                    })
                    .catch(e => {
                        self.isLoading = false
                        // this.errors.push(e)
                        console.log(e)
                    })
                    
            }else{  //for the current month
                this.displayMonth = this.displayMonthName(self.duration)
                axios.defaults.headers.common['Authorization'] = localStorage.getItem('newToken')            
                axios.defaults.responseType = 'json'
                axios.post(process.env.NEW_ENDPOINT + '/form/listSubmissions', {
                        loginEmail: localStorage.getItem('email'),
                        token: localStorage.getItem('newToken'),
                        schoolId: localStorage.getItem('schoolID'),
                        country: localStorage.getItem('country'),
                        formId: self.formId,
                        period: self.period,
                        month: self.duration,
                        year: self.actionYear,
                        displayFormDetails: true
                    })
                    .then(response => {
                        console.log("219 response.data")
                        console.log(response.data)
                        self.listOfSubmissions = response.data.result
                        self.isLoading = false;
                    })
                    .catch(e => {
                        console.log("222 Error:" + e)
                    }) 
            }
        },
        displayDate(date){
            try{
                var getYear = date.substring(0,4);
                var getMonth = date.substring(4,6);
                var getDay = date.substring(6);

                return getDay + "/" + getMonth + "/" + getYear;
            }catch(err){
                console.log(err)
                return date;
            }
        },
        displayInfo(dataType,remarks,status){
            if (dataType == 2){
                if (status == 2){
                    return "Late"
                }else{
                    return "On-Time"
                }
            }else{
                return remarks
            }
        },
        goForms(){
            this.$router.push({
                name: "DbFormMain"
            });
        },
        displayMonthName(month){
            var monthDisplay = "";
            switch (parseInt(month)){
                case 1:
                    monthDisplay = "January";
                    break;
                case 2:
                    monthDisplay = "February";
                    break;
                case 3:
                    monthDisplay = "March";
                    break;
                case 4:
                    monthDisplay = "April";
                    break;
                case 5:
                    monthDisplay = "May";
                    break;
                case 6:
                    monthDisplay = "June";
                    break;
                case 7:
                    monthDisplay = "July";
                    break;
                case 8:
                    monthDisplay = "August";
                    break;
                case 9:
                    monthDisplay = "September";
                    break;
                case 10:
                    monthDisplay = "October";
                    break;
                case 11:
                    monthDisplay = "November";
                    break;
                case 12:
                    monthDisplay = "December";
                    break;
                default:
                    monthDisplay = "January";
                    break;
            }
            return monthDisplay;
        },
        goManageForms() {
            this.$router.push({
                name: "ManageFormsHome"
            });
        },
    },
};
</script>

<style scoped>
.container{
    padding: 10px;
}
.box{
    border: 1px solid #ccc;
    width: 40% !important;
    margin: 4px;
    padding: 0px !important;
}
.active{
    border: 1px solid rgb(6, 50, 247);
}
.datepicker{
    margin-left: 30px;
    border-radius: 4px;
    -moz-outline-radius: 4px;
    height: 2.25em;
    line-height: 1.5;
}
</style>
<style module>
.datepicker input{
    border: none; /* <-- This thing here */
    border:1px solid #1849c8;
    border-radius: 5px;
    text-align: center;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Manage/Forms/Submissions.vue